import styled from 'styled-components'
import { injectModifiers } from 'ui/themes/utils'
import modifiers from 'ui/themes/modifiers'

const Div = styled.div`
  ${({ theme }) => injectModifiers(modifiers(theme))}
`

export default Div
